export default (state = "", action) => {
  if (action.type === "APP_LOADED") {
    return action.app;
  }

  return state;
};
